<template>
    <el-main class="container">
      <Nav>
        <div slot="left">
          <el-input placeholder="请输入产业名称进行搜索" v-model.trim="inputVal" clearable></el-input>
          <el-button type="primary" style="margin-left: 30px" @click="handleSearch">搜索</el-button>
        </div>
        <div slot="right">
          <el-button v-show="hasAuthority('addIndustry')" type="primary" @click="handleAddIndustry">新增产业</el-button>
        </div>
      </Nav>
      <div class="table">
        <Table
          v-loading="loading"
          border
          align="center"
          :header-row-style="{height: '100px'}"
          :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
          :row-style="{height: '150px'}"
          :column="tableData.column"
          :data="tableData.data"
          pagination
          background
          :paginationTop="'30px'"
          :paginationAlign="'center'"
          layout="prev, pager, next, sizes, jumper"
          :page-sizes="[5, 10, 20, 30]"
          :pager-count="5"
          :current-page.sync="body.currentPage"
          :total="datasource.total"
          :page-size="body.pageSize"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </Table>
      </div>
      <el-dialog
        :visible.sync="showApproveDialog"
        width="600px"
      >
        <div class="dialog">
          <div class="title">
            <div>审批人</div>
            <div>(放行审批人拥有放行审批权利)</div>
          </div>
          <div class="audit-box">
            <span v-if="!auditInfo.wxAvatar">暂无审批人</span>
            <div class="content" v-else>
              <div class="img-box">
                <img :src="auditInfo.wxAvatar" alt="">
              </div>
              <div class="name">{{auditInfo.wxName}}</div>
            </div>
          </div>
          <div class="btn-box">
            <el-button @click="showApproveDialog = false">关闭</el-button>
            <el-button type="primary" @click="editor()">编辑</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="showUserDialog"
        width="1200px">
        <div class="dialog">
          <div class="title">
            <div>审批人</div>
            <div>(放行审批人拥有放行审批权利)</div>
          </div>
          <div class="table">
            <div class="search">
              <el-input
                v-model="userBody.word"
                clearable
                placeholder="请输入昵称进行搜索"
                class="input"></el-input>
              <el-button type="primary" @click="userSearch()">搜索</el-button>
            </div>
            <table-pagination
              ref="table"
              :config="userConfig"
              :idRow="true"
              :radio="true"
              :width='100'
              :datasource="userDatasource"
              :selectRadio="selectRadio"
              class="table1"
              @change-radio="handlerSelectAudit"
              @change-page-num="handlerPageNum"
              @change-page="handlerPageChange">
              <el-table-column
                slot="action"
                label="认证状态"
                align="center">
                <template slot-scope="scope">
                  <div>
                    <span
                      v-if="scope.row.isAuthentication === 0">
                      {{ scope.row.isAuthentication | status }}</span>
                    <span
                      v-if="scope.row.isAuthentication === 1"
                      style="color:blue">
                      {{ scope.row.isAuthentication | status }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                slot="action"
                label="所属企业"
                align="center">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.enterpriseName === ''">-</span>
                    <span v-else>
                      {{ scope.row.enterpriseName}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                slot="action"
                label="注册时间"
                align="center">
                <template slot-scope="scope">
                  <div>
                    <span>{{ scope.row.createTime }}</span>
                  </div>
                </template>
              </el-table-column>
            </table-pagination>
          </div>
          <div class="btn-box">
            <el-button @click="back()">返回</el-button>
            <el-button type="primary" @click="setAudit()">设置审批人</el-button>
          </div>
        </div>
      </el-dialog>
     </el-main>
</template>
<script>
import {
  getIndustryList,
  deleteIndustry
} from '@/api/industry'
import { getAuditList, setAudit } from '@/api/electronic'
import { getUserList } from '@/api/user'
import TablePagination from '@/components/table-pagination'
export default {
  // eslint-disable-next-line vue/name-property-casing
  data() {
    return {
      userConfig: {
        size: 5,
        fields: [
          {
            prop: 'wxAvatar',
            label: '头像',
            type: 'wx_image',
            width: '100'
          },
          {
            prop: 'wxName',
            label: '昵称'
          }
        ]
      },
      tableData: {
        column: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'name',
            label: '产业名称'
          },
          {
            prop: 'enterpriseCount',
            label: '企业数量'
          },
          {
            label: '操作',
            width: '300',
            render: (h, scoped) => {
              return (
                <div>
                  <div>
                    <el-link v-show={this.hasAuthority('industryCompany')} underline={false} type='primary' onClick={() => { this.handleGoCompany(scoped.row) }}>企业列表</el-link>&nbsp;&nbsp;
                    <el-link v-show={this.hasAuthority('industryApprover')} underline={false} type='primary' onClick={() => { this.setPassAudit(scoped.row) }}>设置放行审批人</el-link>&nbsp;&nbsp;
                    <el-link v-show={this.hasAuthority('industryVisit')} underline={false} type='primary' onClick={() => { this.handleAction('visit', scoped.row ) }}>拜访记录</el-link>&nbsp;&nbsp;
                  </div>
                  <div>
                    <el-link v-show={this.hasAuthority('editIndustry')} underline={false} type='primary' onClick={() => { this.handleEdit(scoped) }}>编辑</el-link>&nbsp;&nbsp;
                    <el-link v-show={this.hasAuthority('deleteIndustry')} underline={false} type='primary' onClick={() => { this.handleDelete(scoped) }}>删除</el-link>
                  </div>
                </div>
              )
            }
          }

        ],
        data: []
      },
      datasource: {
        total: 0
      },
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      },
      loading: false,
      currentPage: 1,
      pageSize: 5,
      inputVal: '',
      showApproveDialog: false,
      showUserDialog: false,
      // 设置审批人请求体
      approverBody: {
        userUuid: '',
        industryUuid: ''
      },
      userBody: {
        pageSize: 5,
        pageIndex: 1,
        word: '',
        isAuthentication: ''
      },
      userDatasource: {
        total: 0,
        data: []
      },
      //审批人信息
      auditInfo: {},
      //勾选的审批人
      selectRadio: [],
      // 所勾选的发行人信息
      selectAudit: [],
    }
  },
  created() {
    this.network().getIndustryList()
  },
  methods: {
    network() {
      return {
        getIndustryList: async(page) => {
          if (page) {
            this.body.pageIndex = page
          }
          getIndustryList(this.body).then(res => {
            this.tableData.data = res.data.list
            this.datasource.total = res.data.total
          })
        },
        deleteIndustry: async(id) => {
          await deleteIndustry({ uuid: id })
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.network().getIndustryList(1)
        },
        getAuditList: async()=>{
          let { data } = await getAuditList(this.approverBody.industryUuid)
          this.auditInfo = data
        },
        getUserList: async() => {
          const { data } = await getUserList(this.userBody)
          this.userDatasource.total = data.total
          this.userDatasource.data = data.list
          const approve = []
          data.list.forEach((item, index) => {
            if (this.auditInfo.uuid === item.uuid) {
              approve.push(index)
            }
          })
          this.selectRadio = approve
        },
        //设置放行审批人
        setAudit: async() => {
          await setAudit(this.approverBody)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.showUserDialog = false
          this.showApproveDialog = false
        },
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.network().getIndustryList()
    },
    handleCurrentChange(current) {
      this.network().getIndustryList(current)
    },
    handleAddIndustry() {
      this.$router.push('/industry-management/add')
    },
    handleAction(type, row) {
      switch (type) {
        case 'visit':
          this.$router.push({
            path: `company-management/company-visit/get/${row.uuid}`,
            query: {
              info: JSON.stringify(row),
              type: 'industry'
            }
          }); break
      }
    },
    handleEdit(scoped) {
      this.$router.push(`/industry-management/edit/${scoped.row.uuid}`)
    },
    handleDelete(scoped) {
      this.$confirm('是否删除该产业？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteIndustry(scoped.row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSearch() {
      this.body.word = this.inputVal
      this.network().getIndustryList(1)
    },
    handleGoCompany(row){
      this.$router.push({
        path: '/company-management',
        query: {
          id: JSON.stringify(row.uuid)
        }
      })
    },
    setPassAudit(row){
      this.showApproveDialog = true
      this.approverBody.industryUuid = row.uuid
      this.auditInfo = []
      this.network().getAuditList()
    },
    editor(){
      this.showApproveDialog = false
      this.showUserDialog = true
      this.network().getUserList()
    },
    userSearch(){
      this.network().getUserList()
    },
    handlerSelectAudit(data) {
      this.selectAudit = data.radioInfo
    },
    handlerPageChange(data) {
      this.userBody.pageIndex = data.page
      this.network().getUserList()
    },
    handlerPageNum(data) {
      this.userBody.pageSize = data.pageNum
      this.network().getUserList()
    },
    back(){
      this.showUserDialog = false
      this.setPassAudit()
    },
    setAudit(){
      if (this.selectAudit.length === 0 && !this.auditInfo) {
        this.$message.error('请选择审批人')
        return
      }
      if (this.selectAudit.length === 0 && this.auditInfo) {
        this.approverBody.userUuid = this.auditInfo.uuid
      } else this.approverBody.userUuid = this.selectAudit.uuid
      debugger
      this.network().setAudit()
    },
  },
  components: {
    TablePagination
  }
}
</script>
<style lang="scss" scoped>
.industry-list-container{
  height: 100%;
}
.table{
  margin-top: 30px;
}
.dialog{
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: -30px;
      font-weight: bold;
      font-size: 18px;
      flex: 1;
    }
    .audit-box{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      margin: 90px 0;
      flex: 5;
      .img-box{
        width: 150px;
        height: 150px;
      }
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-shadow: 0 0 10px 5px #999;
      }
      .name{
        text-align: center;
        margin-top: 30px;
        font-weight: bold;
        font-size: 20px
      }
    }
    .btn-box{
      flex: 1;
      margin: 15px 0;
      button{
        width: 150px;
      }
    }
    .table{
      width: 100%;
      display: flex;
      flex-direction: column;
      .search{
        width: 30%;
        display: flex;
        margin: 30px 0;
        .input{
          margin-right: 15px;
        }
      }
    }
  }
</style>
